// Components==============
import React, { createContext } from 'react';
// =========================

export const GlobalContext = createContext();

// All values within this context will be persisted on Route change

export default function GlobalContextWrapper({ children }) {
    return (
        <GlobalContext.Provider value={{}}>{children}</GlobalContext.Provider>
    );
}
